import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { CheckPhoneUseCase, IdInterface } from '../../../core';

export const phoneExists = (required: boolean, checkPhoneUseCase: CheckPhoneUseCase, clientCode?: IdInterface): AsyncValidatorFn => {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const v: string = control.value;

        if (!required) {
            return of(null);
        }

        return checkPhoneUseCase.bind(v, clientCode).pipe(
            debounceTime(400),
            distinctUntilChanged(),
            map((transaction) => {
                return transaction.isSuccess && transaction.data ? { phoneExists: true } : null;
            })
        );
    };
};
